import React, { useState } from 'react';

import Helmet from 'react-helmet';

import { PlayButton } from './PlayButton';
import { VideoWrapper, StyledVideoContainer } from './styled-components';

const Youtube = ({ videoId, poster }) => {
  const [ player, setPlayer ] = useState();

  const handleClick = (e) => {
    if (window && typeof(window.YT) != 'undefined') {
      setPlayer(new window.YT.Player('ytplayer', {
        videoId: videoId,
        events: {
          'onReady': onVideoReady,
        },
      }));
    }
  }
  
  const onVideoReady = (e) => {
    e.target.playVideo();
  }

  return(<>
    <Helmet>
      <script src="https://www.youtube.com/iframe_api"></script>
    </Helmet>
    <VideoWrapper onClick={handleClick}>
      <StyledVideoContainer src={poster} isPlayer={!!player} id="ytplayer" />
      {!player && <PlayButton/>}
    </VideoWrapper>    
  </>)
}

export default Youtube;